import { createAction } from '@reduxjs/toolkit'

import { AutomationCapability, AutomationProfile, AutomationTask } from 'types'

const NAMESPACE = 'CAMPAIGN_PAGE/AUTOMATION'

// Automation capabilities
export const fetchCapabilitiesSuccess = createAction<{
    results: AutomationCapability[]
}>(`${NAMESPACE}/FETCH_CAPABILITIES_SUCCESS`)

// Automation tasks
export const fetchTasksSuccess = createAction<{ results: AutomationTask[] }>(
    `${NAMESPACE}/FETCH_TASKS_SUCCESS`
)

// Automation Profiles
export const fetchAutomationProfilesSuccess = createAction<{
    results: AutomationProfile[]
}>(`${NAMESPACE}/FETCH_AUTOMATION_PROFILES_SUCCESS`)

export const fetchAutomationProfilesFailure = createAction<string>(
    `${NAMESPACE}/FETCH_AUTOMATION_PROFILES_FAILURE`
)
